import 'swiper/css/free-mode';
import 'swiper/css/effect-fade';

export default class HorizontalTabs {
    constructor() {
        this.horizontalTabs = document.querySelectorAll('.fd-block-horizontal-tabs')

        this.init();
    }

    init() {
        if(this.horizontalTabs.length) {
            this.horizontalTabs.forEach((elt, index) => {
                const tabs = elt.querySelector('.fd-tabs-buttons .swiper-wrapper');
                const tabButtons = new Swiper('.fd-tabs-buttons', {
                    slidesPerView: 'auto',
                    freeMode: true,
                    on: {
                        tap: function(swiper, event) {
                            tabContent.slideTo(swiper.clickedIndex);
                        }
                    }
                });

                const tabContent = new Swiper('.fd-tabs-content', {
                    effect: 'fade',
                    fadeEffect: { crossFade: true },
                    on: {
                        slideChangeTransitionStart: function(swiper, event) {
                            tabs.children[swiper.previousIndex].classList.remove('active');
                            tabs.children[swiper.activeIndex].classList.add('active');
                        }
                    }
                });
            })
        }
    }
}